import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, IconButton, Menu, Avatar, Box, Button, useMediaQuery, Drawer } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { auth, db, storage } from '../firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { getDownloadURL, ref } from 'firebase/storage';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTheme } from '@mui/system';  // Importer le thème pour le responsive
import { AccountBox, Home, List, MenuRounded, Star } from '@mui/icons-material';
const drawerWidth = 240;


const SidebarIcon = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '1rem 2rem',
    width: '100%',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: '#1f1f1f',
    },
}));
function Header() {

    const [user, setUser] = useState(null);
    const [userData, setUserData] = useState(null);
    const [profileImageUrl, setProfileImageUrl] = useState(null);
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));  // Check si c'est un écran mobile

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
            if (currentUser) {
                setUser(currentUser);
                const userDocRef = doc(db, 'users', currentUser.uid);
                const userDoc = await getDoc(userDocRef);
                if (userDoc.exists()) {
                    const userDataFromFirestore = userDoc.data();
                    setUserData(userDataFromFirestore);
                    if (userDataFromFirestore.profileImageURL) {
                        const imageRef = ref(storage, userDataFromFirestore.profileImageURL);
                        const imageUrl = await getDownloadURL(imageRef);
                        setProfileImageUrl(imageUrl);
                    }
                }
            } else {
                setUser(null);
                setUserData(null);
                setProfileImageUrl(null);
            }
        });

        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate('/login');
        } catch (error) {
            console.error('Erreur lors de la déconnexion :', error);
        }
    };

    const goHome = () => {
        navigate('/');
    };

    const goMyList = () => {
        navigate('/mylist');
    };

    const goProfile = () => {
        navigate('/profile');
    };

    const goLogin = () => {
        navigate('/login');
    };

    const goRegister = () => {
        navigate('/register');
    };

    const handleDrawerToggle = () => {
        setDrawerOpen(!drawerOpen);
    }

    return (
        <>
            <AppBar position="static" sx={{ width: '100%', backgroundColor: 'rgb(37, 150, 190)' }}>
                <Toolbar>

                    <IconButton color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, }}>
                        <MenuRounded />
                    </IconButton>



                    <Typography
                        onClick={goHome}
                        variant="h6"
                        sx={{
                            flexGrow: 1,
                            cursor: 'pointer',
                            fontFamily: 'SUSE, sans-serif',
                            textAlign: isMobile ? 'center' : 'left',  // Center the title on mobile
                        }}
                    >
                        K-Drama Tracker
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        {user ? (
                            <>
                                {/* Profile Avatar and Logout */}
                                <IconButton onClick={goProfile}>
                                    <Avatar
                                        alt={userData?.username || 'Profil'}
                                        src={profileImageUrl || ''}
                                        sx={{ width: isMobile ? 30 : 40, height: isMobile ? 30 : 40 }}  // Adjust avatar size on mobile
                                    >
                                        {profileImageUrl ? null : userData?.username?.charAt(0)?.toUpperCase()}
                                    </Avatar>
                                </IconButton>
                                <Button
                                    color="inherit"
                                    onClick={handleLogout}
                                    sx={{ display: isMobile ? 'none' : 'flex', fontFamily: 'SUSE, sans-serif', alignItems: 'center', gap: 1 }}  // Hide logout button on mobile
                                >
                                    Déconnexion
                                    <LogoutIcon />
                                </Button>
                            </>
                        ) : (
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Typography
                                    onClick={goLogin}
                                    sx={{
                                        cursor: 'pointer',
                                        fontFamily: 'SUSE, sans-serif',
                                        display: isMobile ? 'none' : 'block',  // Hide on mobile
                                    }}
                                >
                                    Se connecter
                                </Typography>
                                <Typography
                                    onClick={goRegister}
                                    sx={{
                                        cursor: 'pointer',
                                        fontFamily: 'SUSE, sans-serif',
                                        display: isMobile ? 'none' : 'block',  // Hide on mobile
                                    }}
                                >
                                    S'inscrire
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Toolbar>
            </AppBar>

            <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={handleDrawerToggle}

                sx={{
                    width: drawerWidth,
                    flexShrink: 0,

                    [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box', backgroundColor: '#121212' },

                }}
            >

                <Toolbar />
                <Box sx={{ overflow: 'auto' }}>
                    <SidebarIcon onClick={goHome}>
                        <Home sx={{ color: 'white', marginRight: '1rem' }} />
                        <Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif' }}>Accueil</Typography>
                    </SidebarIcon>
                    <SidebarIcon onClick={goProfile}>
                        <AccountBox sx={{ color: 'white', marginRight: '1rem' }} />
                        <Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif' }}>Mon Profil</Typography>
                    </SidebarIcon>
                    <SidebarIcon onClick={goMyList}>
                        <Star sx={{ color: 'white', marginRight: '1rem' }} />
                        <Typography sx={{ color: 'white', fontFamily: 'SUSE, sans-serif' }}>Mes listes</Typography>
                    </SidebarIcon>

                </Box>
            </Drawer>
        </>
    );
}

export default Header;
